import ManageStaffTable from "./components/StaffComponents/ManageStaffTable";
import { Box, Card, Grid, Chip, Typography } from "@mui/material";
import { useState, useEffect, useRef } from "react";
import { GridColDef, GridRowId, GridRowModel, GridCallbackDetails, GridRowSelectionModel, GridRow } from "@mui/x-data-grid";
import { useParams } from "react-router";
import { useQuery } from "@apollo/client";
import { TablePaginated, TableToolBar, FetchMoreCallbackArgs, LoadingWrapper } from "ui";
import usePersonStore from "../store/personStore";
import { GET_LOCATION } from "../../features/graphql/query";

const ManageCompanyStaffPage = ({ onBack }: { onBack: () => void }) => {

    const { lid } = useParams();
    const { loading, data } = useQuery(GET_LOCATION, { variables: { id: lid } })
    const [locationName, setLocationName] = useState<string | null>(null);

    useEffect(() => {
        if (data) {
            setLocationName(data?.location?.name)
        }
    }, [loading, data])
    return (
        <LoadingWrapper loading={loading}>
            <Card elevation={4} style={{ width: "100%", height: "auto" }}>
                <ManageStaffTable onBack={onBack} locationName={locationName} />
            </Card>
        </LoadingWrapper>
    )
}


export default ManageCompanyStaffPage
